export const Checkbox = {
  baseStyle: {
    icon: {
      bg: '#605AFB',
      color: '#FFFFFF',
    },
    control: {
      borderRadius: '4px',
      borderWidth: '2px',
      borderColor: '#EAEAEA',
      bg: '#FFF',
      _checked: {
        borderColor: '#605AFB',
        bg: '#605AFB',
      },
      _hover: {
        borderColor: 'light.border',
      },
      _active: {
        outline: 'none',
      },
      _focus: {
        boxShadow: 'none',
      },
    },
    label: {},
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
};
